import { inject } from '@angular/core';
import { CanActivateFn, Router, Routes } from '@angular/router';
import { AuthStore } from '@application/auth.store';
import { AuthCallbackViewComponent } from '@presentation/views/auth-callback-view';
import { LoginViewComponent } from '@presentation/views/login-view';
import { ChatViewComponent } from '@presentation/views/chat-view';

const chatAuthGuard: CanActivateFn = async () => {
  const auth = inject(AuthStore);
  const router = inject(Router);

  await auth.ensureSession();

  return auth.isAuthenticated() ? true : router.createUrlTree(['/login']);
};

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginViewComponent },
  { path: 'auth/callback', component: AuthCallbackViewComponent },
  { path: 'chat', component: ChatViewComponent, canActivate: [chatAuthGuard] },
];
